<template>
  <div>
    <div v-if="isSpinnerShow" class="d-flex justify-content-center mt-3 mb-3">
      <b-spinner label="Loading..."></b-spinner>
    </div>
    <div class="panel-tag mt-3" v-if="!isSpinnerShow && totalEntries == 0">
      {{ $t("table.no_records") }}
    </div>
    <div
      v-if="!isSpinnerShow && totalEntries != 0"
      class="dataTables_wrapper dt-bootstrap4"
    >
      <div class="row justify-content-end">
        <div class="col-auto pt-2">
          <span>{{
            $t("table.pagination", {
              startPage: startPage,
              endPage: endPage,
              totalEntries: totalEntries,
            })
          }}</span>
        </div>
        <div class="col-auto">
          <b-pagination
            class="ml-3"
            v-model="currentPage"
            :per-page="perPage"
            :total-rows="totalEntries"
            @input="handlePagination"
            aria-controls="tblProductItems"
          ></b-pagination>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 overflow-auto">
          <div class="fs-xs fw-300 text-right pt-2 pb-2">
            <button
              type="button"
              class="
                btn btn-xs btn-outline-primary
                waves-effect waves-themed
                mr-2
              "
              @click="showAllDetails"
            >
              {{
                isExpand == "Expand"
                  ? $t("button_link.expand_details")
                  : $t("button_link.collapse_details")
              }}
            </button>
          </div>
          <table
            id="tblVoucherList"
            class="
              table table-sm table-hover table-bordered table-striped
              w-100
              dataTable
              dtr-inline
            "
            role="grid"
          >
            <thead class="thead-themed">
              <tr>
                <th
                  v-for="tblHeader in fields"
                  :key="tblHeader.key"
                  :style="handleExpiryHeader(tblHeader.key)"
                >
                  {{ tblHeader.label }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, k) in voucherItems" :key="k">
                <td class="align-middle">{{ k + startPage }}</td>
                <td class="align-middle">
                  <div v-if="filterObj.listType == 'signup'">
                    {{
                      item.createDate == 0
                        ? "-"
                        : convertTimestampToDateTime(item.createDate)
                    }}
                  </div>
                  <div v-else-if="filterObj.listType == 'redeem'">
                    <div class="border-bottom p-1">
                      <h6 class="text-primary fw-500 fs-sm mb-0">
                        <i class="fal fa-arrow-square-up mr-1"></i
                        >{{ $t("salon_report.voucher.sign_up") }}:
                      </h6>
                      <span class="d-block">{{
                        item.createDate == 0
                          ? "-"
                          : getDateTime(item.createDate).date
                      }}</span>
                      {{
                        item.createDate == 0
                          ? ""
                          : getDateTime(item.createDate).time
                      }}
                    </div>
                    <div class="p-1">
                      <h6 class="text-primary fw-500 fs-sm mb-0">
                        <i class="fal fa-minus-square mr-1"></i
                        >{{ $t("salon_report.voucher.redeem") }}:
                      </h6>
                      <span class="d-block">{{
                        item.redeemDate == 0
                          ? "-"
                          : getDateTime(item.redeemDate).date
                      }}</span>
                      {{
                        item.redeemDate == 0
                          ? ""
                          : getDateTime(item.redeemDate).time
                      }}
                    </div>
                  </div>
                  <div v-else-if="filterObj.listType == 'expired'">
                    <div class="border-bottom p-1">
                      <h6 class="text-primary fw-500 fs-sm mb-0">
                        <i class="fal fa-arrow-square-up mr-1"></i
                        >{{ $t("salon_report.voucher.sign_up") }}:
                      </h6>
                      <span class="d-block">{{
                        item.createDate == 0
                          ? "-"
                          : getDateTime(item.createDate).date
                      }}</span>
                      {{
                        item.createDate == 0
                          ? ""
                          : getDateTime(item.createDate).time
                      }}
                    </div>
                    <div class="p-1">
                      <h6 class="text-primary fw-500 fs-sm mb-0">
                        <i class="fal fa-calendar-exclamation mr-1"></i
                        >{{ $t("salon_report.voucher.expired") }}:
                      </h6>
                      <span class="d-block">{{
                        item.expiredDate == 0
                          ? "-"
                          : getDateTime(item.expiredDate).date
                      }}</span>
                      {{
                        item.expiredDate == 0
                          ? ""
                          : getDateTime(item.expiredDate).time
                      }}
                    </div>
                  </div>
                  <div v-else-if="filterObj.listType == 'expiry'">
                    <div class="border-bottom p-1">
                      <h6 class="text-primary fw-500 fs-sm mb-0">
                        <i class="fal fa-arrow-square-up mr-1"></i
                        >{{ $t("salon_report.voucher.sign_up") }}:
                      </h6>
                      <span class="d-block">{{
                        item.createDate == 0
                          ? "-"
                          : getDateTime(item.createDate).date
                      }}</span>
                      {{
                        item.createDate == 0
                          ? ""
                          : getDateTime(item.createDate).time
                      }}
                    </div>
                    <div class="p-1">
                      <h6 class="text-primary fw-500 fs-sm mb-0">
                        <i class="fal fa-calendar-exclamation mr-1"></i
                        >{{ $t("table.header.expiry") }}:
                      </h6>
                      <span class="d-block">{{
                        item.expiryDate == 0
                          ? "-"
                          : getDateTime(item.expiryDate).date
                      }}</span>
                      {{
                        item.expiryDate == 0
                          ? ""
                          : getDateTime(item.expiryDate).time
                      }}
                    </div>
                  </div>
                  <div v-else>
                    <div class="border-bottom p-1">
                      <h6 class="text-primary fw-500 fs-sm mb-0">
                        <i class="fal fa-arrow-square-up mr-1"></i
                        >{{ $t("salon_report.voucher.sign_up") }}:
                      </h6>
                      <span class="d-block">{{
                        item.createDate == 0
                          ? "-"
                          : getDateTime(item.createDate).date
                      }}</span>
                      {{
                        item.createDate == 0
                          ? ""
                          : getDateTime(item.createDate).time
                      }}
                    </div>
                    <div class="border-bottom p-1">
                      <h6 class="text-primary fw-500 fs-sm mb-0">
                        <i class="fal fa-minus-square mr-1"></i
                        >{{ $t("salon_report.voucher.redeem") }}:
                      </h6>
                      <span class="d-block">{{
                        item.redeemDate == 0
                          ? "-"
                          : getDateTime(item.redeemDate).date
                      }}</span>
                      {{
                        item.redeemDate == 0
                          ? ""
                          : getDateTime(item.redeemDate).time
                      }}
                    </div>
                    <div class="p-1">
                      <h6 class="text-primary fw-500 fs-sm mb-0">
                        <i class="fal fa-calendar-exclamation mr-1"></i
                        >{{ $t("salon_report.voucher.expired") }}:
                      </h6>
                      <span class="d-block">{{
                        item.expiredDate == 0
                          ? "-"
                          : getDateTime(item.expiredDate).date
                      }}</span>
                      {{
                        item.expiredDate == 0
                          ? ""
                          : getDateTime(item.expiredDate).time
                      }}
                    </div>
                  </div>
                </td>
                <td class="align-middle">
                  <div class="d-flex justify-content-between">
                    <a
                    class="fw-500 text-primary link"
                    @click="showDetails($event,k)"
                    >{{ item.voucherName }}</a
                  >
                  <div v-if="!item.redeemStatus">
                    <b-button
                        class="mr-2 border-0"
                        pill
                        size="xs"
                        variant="outline-danger"
                        style="display:none;"
                        :id="`deleteVoucher[${k}]`"
                        @click="voucherEmit(item.trxnID, 'delete')"
                        ><b-icon icon="trash"></b-icon></b-button>
                  
                  </div>
                  </div>
                  <div class="mt-1 voucherDetailTable" style="display: none">
                    <table
                      class="
                        table table-sm table-hover table-bordered table-striped
                      "
                    >
                      <tr>
                        <th>{{ $t("table.header.type") }}</th>
                        <td>
                          {{ $t("salon_report.item_types." + item.type) }}
                        </td>
                      </tr>
                      <tr>
                        <th @click="priceEdit[k].view = true, savedPrice = priceEdit[k].price">
                          {{ $t("label.unit_price") }}
                        </th>
                        <td>
                          <div v-if="priceEdit[k].view && item.redeemDate == 0 && item.expiredDate == 0" class="d-flex">
                            <input
                            type="text"
                            style="width: 150px;"
                            v-model="priceEdit[k].price"
                            class="form-control"
                            @input="validationCheck"
                            :class="!validationFlag ? 'highlightRed':''"
                          />
                          <b-button size="sm" variant="primary" :disabled="!validationFlag || validationFlag == null" class="mx-1" @click="updateVoucherUnitPrice(priceEdit[k])">Confirm</b-button>
                          <b-button size="sm" variant="secondary" @click="priceEdit[k].view = false, priceEdit[k].price = savedPrice">Cancel</b-button>
                          </div>
                          <span v-else>{{
                            formatPrice(item.unitPrice)
                          }}</span>
                        </td>
                      </tr>
                      <tr>
                        <th>
                          {{
                            $t("subMenu.my_salon_member") +
                            $t("table.header.name")
                          }}
                        </th>
                        <td>{{ item.memberDisplayName }}</td>
                      </tr>
                      <tr>
                        <th>{{ $t("table.header.contact") }}</th>
                        <td>{{ item.mobile }}</td>
                      </tr>
                    </table>
                  </div>
                </td>
                <!-- <td class="align-middle">
                  {{
                    getOrderID(
                      item.redeemDate,
                      item.expiredDate,
                      item.workID,
                      item.recvWorkID
                    )
                  }}
                </td> -->
                <td class="align-middle">
                  {{getReceiptNumber(item.trxnID)}}
                </td>
                <td class="align-middle">
                  <div v-if="filterObj.listType == 'signup'">
                    <span class="badge badge-primary">{{
                      $t("salon_report.voucher.sign_up")
                    }}</span>
                  </div>
                  <div v-else>
                    <span
                      v-if="item.redeemDate == 0 && item.expiredDate == 0"
                      class="badge badge-primary"
                      >{{ $t("salon_report.voucher.sign_up") }}</span
                    >
                    <span
                      v-if="item.redeemDate != 0"
                      class="badge badge-warning"
                      >{{ $t("salon_report.voucher.redeem") }}</span
                    >
                    <span
                      v-if="item.expiredDate != 0"
                      class="badge badge-danger"
                      >{{ $t("salon_report.voucher.expired") }}</span
                    >
                  </div>
                </td>
                <td
                  v-show="filterObj.listType != 'expiry'"
                  class="align-middle"
                >
                  {{
                    item.expiryDate == 0
                      ? "-"
                      : convertTimestampToDateTime(item.expiryDate)
                  }}
                </td>
                <td class="align-middle">{{ getOutletName(item.outletID) }}</td>
                <td class="align-middle">
                  {{
                    item.consumeOutletID == 0
                      ? "-"
                      : getOutletName(item.consumeOutletID)
                  }}
                </td>
                <td class="align-middle">
                  <b-button
                    variant="danger"
                    class="w-100"
                    v-if="item.redeemDate != 0 && item.redeemDate != undefined && unredeemValidation(item.trxnID)"
                    @click="voucherEmit(item.trxnID, 'unredeem')"
                    >Unredeem</b-button
                  >
                  <b-button
                    variant="danger"
                    class="w-100"
                    v-else-if="expiryCheck(item.expiredDate)"
                    @click="voucherEmit(item.trxnID, 'unexpire')"
                    >Unexpire</b-button>
                  <!-- <b-button
                    class="w-100"
                    variant="danger"
                    v-else-if="!redeemedCheck(item.trxnID)"
                    @click="voucherEmit(item.trxnID, 'delete')"
                    >Delete</b-button
                  > -->
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from "lodash";
import { vMaska } from "maska";
import moment from "moment";
import Swal from "sweetalert2";
import {
  handleSessionExpired,
  setReturnData,
  getOutletName,
} from "./../../../../assets/js/dashboard/dashboard";
import { formatPrice } from "./../../../../assets/js/dashboard/utilities";
export default {
  name: "voucherList",
  directives: { maska: vMaska },
  data() {
    return {
      actionStatus: "",
      actionClasss: "",
      isSpinnerShow: false,
      filterObj: {},
      outlet: [],
      voucherItems: [], voucherClone:[],
      isExpand: "Expand",
      exportData: [],
      page: 0,
      totalEntries: 0,
      totalPage: 0,
      startPage: 1,
      endPage: 0,
      perPage: 100,
      currentPage: 1,
      priceEdit: [],
      validationFlag:null,
      savedPrice: 0
    };
  },
  computed: {
    fields() {
      return [
        { key: "index", label: "#" },
        { key: "date", label: this.$i18n.t("table.header.date") },
        { key: "voucher", label: this.$i18n.t("table.header.voucher") },
        { key: "orderID", label: "Receipt ID" },
        { key: "action", label: "" },
        { key: "expDate", label: this.$i18n.t("label.expiry_date") },
        {
          key: "outlet",
          label:
            this.$i18n.t("salon_report.voucher.sign_up") +
            this.$i18n.t("table.header.outlet"),
        },
        {
          key: "redOutlet",
          label:
            this.$i18n.t("salon_report.voucher.redeem") +
            "/" +
            this.$i18n.t("salon_report.voucher.expired") +
            this.$i18n.t("table.header.outlet"),
        },
        {
          key: "rollback",
          label: "Action",
        },
      ];
    },
    exportFields() {
      var ret = [];
      ret["#"] = "index";
      ret[
        (
          this.$i18n.t("salon_report.voucher.sign_up") +
          this.$i18n.t("table.header.date")
        ).toUpperCase()
      ] = "signupDate";
      ret[
        (
          this.$i18n.t("salon_report.voucher.redeem") +
          this.$i18n.t("table.header.date")
        ).toUpperCase()
      ] = "redeemDate";
      ret[
        (
          this.$i18n.t("salon_report.voucher.expired") +
          this.$i18n.t("table.header.date")
        ).toUpperCase()
      ] = "expiredDate";
      ret[this.$i18n.t("table.header.voucher").toUpperCase()] = "voucher";
      ret[this.$i18n.t("table.header.type").toUpperCase()] = "type";
      ret[this.$i18n.t("label.unit_price").toUpperCase()] = "unitPrice";
      ret[
        (
          this.$i18n.t("subMenu.my_salon_member") +
          this.$i18n.t("table.header.name")
        ).toUpperCase()
      ] = "memberName";
      ret[this.$i18n.t("table.header.contact").toUpperCase()] = "mobile";
      ret[this.$i18n.t("table.header.order_id").toUpperCase()] = "orderID";
      ret[this.$i18n.t("table.action").toUpperCase()] = "action";
      ret[this.$i18n.t("label.expiry_date").toUpperCase()] = "expiryDate";
      ret[
        (
          this.$i18n.t("salon_report.voucher.sign_up") +
          this.$i18n.t("table.header.outlet")
        ).toUpperCase()
      ] = "outlet";
      ret[
        (
          this.$i18n.t("salon_report.voucher.redeem") +
          "/" +
          this.$i18n.t("salon_report.voucher.expired") +
          this.$i18n.t("table.header.outlet")
        ).toUpperCase()
      ] = "redeemOutlet";
      return ret;
    },
  },
  watch: {
    "$i18n.locale"(val) {
      if (this.$parent.selectedTab == "list") {
        this.setExportData(this.exportData);
      }
    },
  },
  methods: {
    redeemedCheck(trxnID){
      let voucher = this.voucherClone.find((e)=>e.trxnID == trxnID);
      if(voucher != undefined && voucher.redeemed != undefined && voucher.redeemed.receiptNumber != 0 && voucher.redeemed.saleID != 0){
        return true;
      }
      else{
        return false;
      }

    },
    unredeemValidation(trxnID){
      let voucher = this.voucherClone.find((e)=>e.trxnID == trxnID);
      if(voucher != undefined && voucher.redeemed.saleID == 0 && voucher.redeemed.receiptNumber == 0){
        return true;
      }
      else{
        return false;
      }

    },
    getReceiptNumber(trxnID){
        let voucher = this.voucherClone.find((e)=>e.trxnID == trxnID);
      if(voucher != undefined)
      {
        if(voucher.redeemed != undefined)
        return voucher.redeemed.receiptNumber == 0 ? this.$i18n.t("salon_report.stock.manual"):voucher.redeemed.receiptNumber;
        else
        return voucher.purchased.receiptNumber;
      }
    },
    validationCheck(el){
      if(isNaN(el.target.value)){
        this.validationFlag = false;
      }
      else{
        this.validationFlag = true;
      }
    },
    expiryCheck(date) {
      date = date == "-" ? 0 : date;
      var formattedDate = new Date(date * 1000);
      if (formattedDate < new Date() && date != 0){
        return true;
      } else {
        return false;
      }
    },
    async updateVoucherUnitPrice(item) {
      const result = await this.voucherEdit(item.trxnID, item.price, "price");
      if (result.status == 200) {
        this.toastrExe(
          "Voucher Update",
          `Successfully edit unit price for ID: ${item.trxnID}`,
          "success"
        );
        this.getVoucherList(this.filterObj);
      }
    },
    async voucherEmit(id, operation) {
      let flag = false;
      await Swal.fire({
        title: `Confirm ${operation} voucher?`,
        showCancelButton: true,
        confirmButtonText: operation,
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          flag = true;
        } else if (result.isDismissed) {
          flag = false;
        }
      });
      if (!flag) {
        return;
      }
      let url = this.$api.VOUCHER;
      url = url + id + "/" + operation;
      var result = [];
      this.isSpinnerShow = true;
      await this.$axios({
        method: "post",
        url: url,
        headers: { token: this.$session.get("token") },
      })
        .then(function (response) {
          result = response;
        })
        .catch((err) => {
          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });
      if (result.status == 200) {
        let body = "";
        if (operation.includes("unexpire")) {
          body = `Unexpired voucher ID: ${id}`;
        } else if (operation.includes("unredeem")) {
          body = `Unredeemed voucher ID: ${id}`;
        } else if (operation.includes("delete")) {
          body = `Deleted voucher ID: ${id}`;
        }
        this.toastrExe("Voucher Update", body, "success");
      } else {
        let body = "Operation failed!";
        this.toastrExe("Voucher Update", body, "danger");
      }
      await this.getVoucherList(this.filterObj);
      this.isSpinnerShow = false;
    },
    async voucherEdit(id, num, operation) {
      let url = this.$api.VOUCHER;
      let body = {};
      let result = {};
      if (operation == "expiry") {
        body = { expiryDate: num.toString() };
      } else if (operation == "price") {
        body = { price: num };
      }
      url = url + id + "/" + operation;
      await this.$axios({
        method: "post",
        url: url,
        data: body,
        headers: { token: this.$session.get("token") },
      })
        .then(function (response) {
          result = response;
        })
        .catch((err) => {
          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });
      return result;
    },
    toastrExe(title, body, variant) {
      this.$bvToast.toast(body, {
        title: title,
        variant: variant,
        solid: true,
      });
    },
    handleExpiryHeader(id) {
      if (id == "expDate") {
        if (this.filterObj.listType == "expiry") {
          return "display: none;";
        }
      } else {
        return {};
      }
    },
    convertTimestampToDateTime(date) {
      return moment.unix(date).format(this.$msg.CST.DATE_TIME_24);
    },
    getDateTime(date) {
      var objDate = {
        date: moment.unix(date).format(this.$msg.CST.DATE_FORMAT),
        time: moment.unix(date).format("hh:mm A"),
      };
      return objDate;
    },
    formatPrice(price) {
      return formatPrice(price);
    },
    getOutletName(id) {
      return getOutletName(id, this.outlet);
    },
    getOrderID(redeemDate, expiredDate, workID, recvWorkID) {
      var orderID = "";
      if (redeemDate == 0 && expiredDate == 0) {
        orderID =
          recvWorkID == 0
            ? this.$i18n.t("salon_report.stock.manual")
            : recvWorkID;
      } else {
        orderID =
          workID == 0 ? this.$i18n.t("salon_report.stock.manual") : workID;
      }
      return orderID;
    },
    showDetails(e,k) {
      let ele = document.getElementById(`deleteVoucher[${k}]`);
      if(ele !== null){
      ele.style.display =
      ele.style.display == "none" ? "block" : "none";
      }
      var link = e.target;
      let detailsDiv = null; 
      
      detailsDiv = link.parentNode.nextSibling;
      detailsDiv.style.display =
      detailsDiv.style.display == "none" ? "block" : "none";
      
      
      var hideCount = 0;
      var detailsContainer = document
        .getElementById("tblVoucherList")
        .querySelectorAll(".voucherDetailTable");

      for (var i = 0; i < detailsContainer.length; i++) {
        if (detailsContainer[i].style.display == "none") {
          hideCount++;
        }
      }
      this.isExpand =
        hideCount == this.voucherItems.length ? "Expand" : "Collapse";
    },
    showAllDetails() {
      var isExpand = false;
      if (this.isExpand == "Expand") {
        isExpand = true;
        this.isExpand = "Collapse";
      } else {
        isExpand = false;
        this.isExpand = "Expand";
      }
      var detailsContainer = document
        .getElementById("tblVoucherList")
        .querySelectorAll(".voucherDetailTable");
      for (var i = 0; i < detailsContainer.length; i++) {
        if (isExpand) {
          if (detailsContainer[i].style.display == "none") {
            detailsContainer[i].style.display = "block";
          }
        } else {
          if (detailsContainer[i].style.display == "block") {
            detailsContainer[i].style.display = "none";
          }
        }
      }
    },
    async getVoucherList(filterObj) {
      let $vm = this;
      this.filterObj = filterObj;

      var dateFilter = "";
      var outletFilter = "";
      switch (filterObj.listType) {
        case "signup":
          dateFilter =
            "?startCreateDate=" +
            moment(filterObj.date.startDate).unix() +
            "&endCreateDate=" +
            moment(filterObj.date.endDate).unix();
          //  + "&status=new"
          outletFilter =
            filterObj.outletID == "all"
              ? ""
              : "&outletID=" + filterObj.outletID;
          break;
        case "redeem":
          dateFilter =
            "?startRedeemDate=" +
            moment(filterObj.date.startDate).unix() +
            "&endRedeemDate=" +
            moment(filterObj.date.endDate).unix();
          outletFilter =
            filterObj.outletID == "all"
              ? ""
              : "&consumeOutletID=" + filterObj.outletID;
          break;
        case "expired":
          dateFilter =
            "?startExpiredDate=" +
            moment(filterObj.date.startDate).unix() +
            "&endExpiredDate=" +
            moment(filterObj.date.endDate).unix();
          outletFilter =
            filterObj.outletID == "all"
              ? ""
              : "&consumeOutletID=" + filterObj.outletID;
          break;
        case "expiry":
          dateFilter =
            "?startExpiryDate=" +
            moment(filterObj.date.startDate).unix() +
            "&endExpiryDate=" +
            moment(filterObj.date.endDate).unix() +
            "&status=new";
          outletFilter =
            filterObj.outletID == "all"
              ? ""
              : "&outletID=" + filterObj.outletID;
          break;
        default:
          dateFilter =
            "?startTrxnDate=" +
            moment(filterObj.date.startDate).unix() +
            "&endTrxnDate=" +
            moment(filterObj.date.endDate).unix();
          outletFilter =
            filterObj.outletID == "all"
              ? ""
              : "&outletID=" + filterObj.outletID;
          break;
      }
      var searchVoucher =
        filterObj.searchVoucher == ""
          ? ""
          : "&search=" + filterObj.searchVoucher;
      var searchCustomer =
        filterObj.searchCustomer == ""
          ? ""
          : "&searchMember=" + filterObj.searchCustomer;
      var searchFilter = searchVoucher + searchCustomer;

      let QUERY_STRING =
        dateFilter + "&page=" + $vm.page + outletFilter + searchFilter;
      const url = this.$api.REPORT_VOUCHER + QUERY_STRING;
      const url2 = this.$api.VOUCHER + dateFilter + "&limit=100000";
      $vm.isSpinnerShow = true;
      var result = {};
      $vm.priceEdit = [];
      
      await $vm
        .$axios({
          method: "get",
          url: url2,
          headers: { token: $vm.$session.get("token") },
        })
        .then(function (response) {
          $vm.voucherClone = response.data.vouchers;
        })
        .catch((err) => {
          var error = err.response.error;
          if (error == $vm.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });

      await $vm
        .$axios({
          method: "get",
          url: url,
          baseURL: $vm.$axios.defaults.baseURL,
          headers: { token: $vm.$session.get("token") },
        })
        .then(function (response) {
          result = setReturnData(
            response.data.result,
            response.data.count,
            $vm.page
          );
          $vm.voucherItems = result.result;
          $vm.voucherItems.forEach((element) => {
            element.deleteView = false;
            element.redeemStatus = $vm.redeemedCheck(element.trxnID);
            $vm.priceEdit.push({
              trxnID: element.trxnID,
              voucherID: element.voucherID,
              price: element.unitPrice,
              view: false,
            });
          });
          $vm.totalEntries = response.data.count;
          $vm.totalPage = result.totalPage;

          $vm.startPage = result.startPage;
          $vm.endPage = result.endPage;
          $vm.isSpinnerShow = false;
        })
        .catch((err) => {
          var error = err.response.error;
          if (error == $vm.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });
      await this.getExportData(dateFilter + outletFilter + searchFilter);
    },
    async getExportData(strFilter) {
      let $vm = this;
      const url = this.$api.REPORT_VOUCHER + strFilter;
      var result = {};
      await $vm
        .$axios({
          method: "get",
          url: url,
          baseURL: $vm.$axios.defaults.baseURL,
          headers: { token: $vm.$session.get("token") },
        })
        .then(function (response) {
          result = response.data.result;
        })
        .catch((err) => {
          var error = err.response.error;
          if (error == $vm.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });
      this.exportData = result;
      this.setExportData(result);
    },
    setExportData(data) {
      var fields = Object.assign({}, this.exportFields);
      var strDate =
        moment(this.filterObj.date.startDate).format(
          this.$msg.CST.DATE_FORMAT
        ) +
        " - " +
        moment(this.filterObj.date.endDate).format(this.$msg.CST.DATE_FORMAT);

      let header =
        this.$msg.REPORT.HEADER +
        this.$i18n.t(`subMenu.salon_report_voucher`) +
        "(" +
        this.$i18n.messages[this.$i18n.locale].tab.reportCreditTabs[1].text +
        ")";
      var exportHeaders = [
        this.$msg.REPORT.HEADER + this.$i18n.t(`subMenu.salon_report_voucher`),
        this.$i18n.t("table.header.date") + ": " + strDate,
        this.$i18n.t("table.report_generate") +
          moment().format(this.$msg.CST.DATE_TIME_24),
        this.$i18n.t("label.outlet") +
          ": " +
          (this.filterObj.outletID == "all"
            ? this.$i18n.t("label.all", { item: this.$i18n.t("label.outlet") })
            : this.getOutletName(this.filterObj.outletID)),
        " ",
      ];
      var exportFileName =
        header.split(" ").join("_") + strDate + this.$msg.REPORT.CSV;

      var exportData = [];
      for (var i = 0; i < data.length; i++) {
        var obj = {
          index: i + 1,
          orderID: data[i].workID == "" ? "-" : data[i].workID,
          voucher: data[i].voucherName,
          type: data[i].type,
          unitPrice: data[i].unitPrice,
          memberName: data[i].memberDisplayName,
          mobile: data[i].mobile,
          action: this.getAction(
            data[i].createDate,
            data[i].redeemDate,
            data[i].expiredDate
          ),
          expiryDate:
            data[i].expiryDate == 0
              ? "-"
              : this.convertTimestampToDateTime(data[i].expiryDate),
          outlet: this.getOutletName(data[i].outletID),
          redeemOutlet:
            data[i].consumeOutletID == 0
              ? "-"
              : this.getOutletName(data[i].consumeOutletID),
        };
        if (this.filterObj.listType == "all") {
          obj["signupDate"] =
            data[i].createDate == 0
              ? "-"
              : this.convertTimestampToDateTime(data[i].createDate);
          obj["redeemDate"] =
            data[i].redeemDate == 0
              ? "-"
              : this.convertTimestampToDateTime(data[i].redeemDate);
          obj["expiredDate"] =
            data[i].expiredDate == 0
              ? "-"
              : this.convertTimestampToDateTime(data[i].expiredDate);
        } else {
          var key = this.filterObj.listType + "Date";
          obj["signupDate"] =
            data[i].createDate == 0
              ? "-"
              : this.convertTimestampToDateTime(data[i].createDate);
          switch (this.filterObj.listType) {
            case "signup":
            case "expiry":
              delete fields[
                (
                  this.$i18n.t("salon_report.voucher.redeem") +
                  this.$i18n.t("table.header.date")
                ).toUpperCase()
              ];
              delete fields[
                (
                  this.$i18n.t("salon_report.voucher.expired") +
                  this.$i18n.t("table.header.date")
                ).toUpperCase()
              ];
              break;
            case "redeem":
              obj[key] =
                data[i].redeemDate == 0
                  ? "-"
                  : this.convertTimestampToDateTime(data[i].redeemDate);
              delete fields[
                (
                  this.$i18n.t("salon_report.voucher.expired") +
                  this.$i18n.t("table.header.date")
                ).toUpperCase()
              ];
              break;
            case "expired":
              obj[key] =
                data[i].expiredDate == 0
                  ? "-"
                  : this.convertTimestampToDateTime(data[i].expiredDate);
              delete fields[
                (
                  this.$i18n.t("salon_report.voucher.redeem") +
                  this.$i18n.t("table.header.date")
                ).toUpperCase()
              ];
              break;
          }
        }
        exportData.push(obj);
      }
      var exportObj = {
        data: exportData,
        fields: fields,
        headers: exportHeaders,
        fileName: exportFileName,
      };

      this.$emit("setExportData", exportObj);
    },
    getAction(purchase, redeem, expired) {
      var action = "";
      if (redeem == 0 && expired == 0) {
        action = this.$i18n.t("salon_report.voucher.sign_up");
      } else {
        action =
          expired != 0
            ? this.$i18n.t("salon_report.voucher.expired")
            : this.$i18n.t("salon_report.voucher.redeem");
      }
      return action;
    },
    async handlePagination(pg) {
      if (pg != null) {
        this.page = pg - 1;
        await this.getVoucherList(this.filterObj);
      }
    },
  },
  async mounted() {
    let $vm = this;
    $vm.outlet = JSON.parse(await $vm.$store.state.outlets);
  },
};
</script>
<style>
.highlightRed{
  border:1.5px solid red;
  background-color: rgb(217, 158, 158);
}
</style>
